import React from 'react';

export default React.memo(function CardSkeleton({className}) {
  return (
    <li
      className={`relative skeleton flex-1 w-full h-full flex-col justify-center overflow-hidden rounded-3xl ${className}`}>

      <div id={'card-grid'}
           className={'absolute bottom-0 w-full h-2/5 grid grid-rows-[1fr_max-content_minmax(max-content,_3fr)]  gap-6 justify-items-center md:justify-items-start bg-black/10'}>
      </div>
    </li>
  );
})
